import styled from 'styled-components';
import { motion } from 'framer-motion';

export const CreateOrderContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[6]};
  padding: 0 ${({ theme }) => theme.spacing[4]};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 0 ${({ theme }) => theme.spacing[3]};
    gap: ${({ theme }) => theme.spacing[4]};
  }
`;

export const PageHeaderCard = styled(motion.div)`
  background-color: white;
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  padding: ${({ theme }) => theme.spacing[8]};
  box-shadow: ${({ theme }) => theme.shadows.md};
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing[8]};

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[4]};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: ${({ theme }) => theme.spacing[5]};
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing[5]};
  flex: 1;
`;

export const IconWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing[4]};
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);

  svg {
    color: white;
    width: 24px;
    height: 24px;
  }
`;

export const TitleGroup = styled.div``;

export const Title = styled.h2`
  font-size: ${({ theme }) => theme.typography.fontSize['2xl']};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  color: ${({ theme }) => theme.colors.gray800};
`;

export const Subtitle = styled.p`
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  color: ${({ theme }) => theme.colors.gray500};
  margin-top: ${({ theme }) => theme.spacing[1]};
`;

export const FormCard = styled(motion.div)`
  background-color: white;
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  padding: ${({ theme }) => theme.spacing[8]};
  box-shadow: ${({ theme }) => theme.shadows.md};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: ${({ theme }) => theme.spacing[4]};
  }
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[6]};
`;

export const Section = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing[8]};
  padding: ${({ theme }) => theme.spacing[6]};
  background-color: #F9FAFB;
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  border: 1px solid ${({ theme }) => theme.colors.gray100};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: ${({ theme }) => theme.spacing[4]};
    margin-bottom: ${({ theme }) => theme.spacing[6]};
  }
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[4]};

  h3 {
    font-size: 16px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.gray800};
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const SectionIcon = styled.span`
  margin-right: ${({ theme }) => theme.spacing[2]};
`;

export const SectionHeader = styled.h3`
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.gray800};
  margin-bottom: ${({ theme }) => theme.spacing[6]};
  padding-bottom: ${({ theme }) => theme.spacing[4]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray200};

  svg {
    color: ${({ theme }) => theme.colors.primary};
    width: 20px;
    height: 20px;
    margin-right: ${({ theme }) => theme.spacing[3]};
  }
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${({ theme }) => theme.spacing[6]};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`;

export const AddressGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${({ theme }) => theme.spacing[6]};

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    grid-template-columns: 1fr;
  }
`;

export const AddressCard = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: ${({ theme }) => theme.spacing[4]};
  background: white;
  padding: ${({ theme }) => theme.spacing[5]};
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  border-radius: ${({ theme }) => theme.borderRadius.lg};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-template-columns: 1fr;
  }
`;

export const FormGroup = styled.div<{ $span?: number }>`
  display: flex;
  flex-direction: column;
  grid-column: span ${({ $span }) => $span || 3};
  gap: 6px;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-column: span 1;
  }
`;

export const Label = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.gray600};
`;


export const TextArea = styled.textarea`
  width: 100%;
  padding: 10px 14px;
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  border-radius: 8px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.gray800};
  outline: none;
  resize: vertical;
  min-height: 80px;
  transition: all 0.2s ease;

  &:focus {
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.primary}15;
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: ${({ theme }) => `${theme.spacing[3]} ${theme.spacing[4]}`};
  border: 1px solid ${({ theme }) => theme.colors.gray300};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  color: ${({ theme }) => theme.colors.gray800};
  background-color: white;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:focus {
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.primary}20;
  }
`;

export const ItemsCard = styled(motion.div)`
  background-color: white;
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  padding: ${({ theme }) => theme.spacing[6]};
  box-shadow: ${({ theme }) => theme.shadows.md};
`;

export const ItemsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing[6]};
`;

export const ItemsTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[3]};
`;

export const ItemsTitle = styled.h2`
  font-size: ${({ theme }) => theme.typography.fontSize.xl};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.gray800};
`;

export const RowMetaBar = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[2]};
  padding: ${({ theme }) => `${theme.spacing[1]} ${theme.spacing[2]}`};
  border-radius: ${({ theme }) => theme.borderRadius.full};
  background: ${({ theme }) => theme.colors.gray100};
  color: ${({ theme }) => theme.colors.gray600};
  font-size: 12px;
`;

export const TableContainer = styled.div`
  overflow: auto;
  max-height: 70vh;
  max-width: 100%;
`;

export const Table = styled.table`
  min-width: 1000px;
  width: 100%;
  table-layout: auto;
  border-bottom: 2px solid ${({ theme }) => theme.colors.primary};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;

export const TableHead = styled.thead`
  tr {
    background-color: ${({ theme }) => theme.colors.gray0 || '#f8fafc'};
    color: ${({ theme }) => theme.colors.gray700};
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray200};
  }
`;

export const TableHeader = styled.th`
  padding: 10px 12px;
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  text-align: left;
  font-size: 13px;
  letter-spacing: 0.01em;
`;

export const TableBody = styled.tbody``;

export const TableRow = styled(motion.tr)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray100};
  transition: background-color 0.15s ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.colors.gray0 || '#f8fafc'};
  }
`;

export const TableCell = styled.td`
  padding: 12px;
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.gray800};
  font-size: 14px;
  height: 52px;
`;


export const EditableSelect = styled.select`
  width: 100%;
  padding: ${({ theme }) => `${theme.spacing[1]} ${theme.spacing[2]}`};
  border: 1px solid ${({ theme }) => theme.colors.gray300};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  outline: none;
  background-color: white;

  &:focus {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[2]};
`;

export const AdvancedRow = styled.tr`
  background: ${({ theme }) => theme.colors.gray0};
`;

export const AdvancedMeta = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: ${({ theme }) => theme.spacing[4]};
  font-size: 13px;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-template-columns: 1fr;
  }
`;

export const AdvancedLabel = styled.div`
  color: ${({ theme }) => theme.colors.gray500};
  margin-bottom: 4px;
`;

export const AdvancedValue = styled.div`
  color: ${({ theme }) => theme.colors.gray800};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
`;

export const CompactEmpty = styled.div`
  padding: ${({ theme }) => theme.spacing[4]};
  text-align: center;
  color: ${({ theme }) => theme.colors.gray600};
  background: ${({ theme }) => theme.colors.gray0};
  border: 1px dashed ${({ theme }) => theme.colors.gray200};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
`;

export const TotalsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${({ theme }) => theme.spacing[6]};

  @media (max-width: ${({ theme }) => theme.breakpoints.xl}) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-template-columns: 1fr;
  }
`;

export const TotalCard = styled.div`
  background-color: white;
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  padding: ${({ theme }) => theme.spacing[4]};
  box-shadow: ${({ theme }) => theme.shadows.md};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TotalContent = styled.div`
  padding: ${({ theme }) => theme.spacing[4]};
`;

export const TotalLabel = styled.p`
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.gray600};
`;

export const TotalValue = styled.p`
  font-size: ${({ theme }) => theme.typography.fontSize['2xl']};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  color: ${({ theme }) => theme.colors.gray800};
  margin-top: ${({ theme }) => theme.spacing[1]};
`;

export const TotalIcon = styled.div<{ $color: string }>`
  padding: ${({ theme }) => theme.spacing[3]};
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  background-color: ${({ $color }) => $color};
  display: inline-block;
  margin-bottom: ${({ theme }) => theme.spacing[2]};

  svg {
    color: white;
    width: 24px;
    height: 24px;
  }
`;

export const FormActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing[4]};
  padding-top: ${({ theme }) => theme.spacing[6]};
  border-top: 1px solid ${({ theme }) => theme.colors.gray200};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    position: sticky;
    bottom: 0;
    background: white;
    padding: ${({ theme }) => theme.spacing[4]};
    margin: 0 -${({ theme }) => theme.spacing[8]};
    box-shadow: 0 -4px 6px -1px rgb(0 0 0 / 0.1);
    z-index: 10;
  }
`;

export const StatusBadge = styled.span<{ $status: 'missing' | 'confirmed' | 'review' }>`
  padding: 4px 10px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  gap: 4px;

  ${({ $status }) => {
    switch ($status) {
      case 'missing':
        return `
          background-color: #FEF3C7;
          color: #92400E;
        `;
      case 'confirmed':
        return `
          background-color: #D1FAE5;
          color: #065F46;
        `;
      case 'review':
        return `
          background-color: #FFEDD5;
          color: #9A3412;
        `;
    }
  }}
`;

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.spacing[4]} 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray100};

  &:last-child {
    border-bottom: none;
  }
`;

export const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[3]};
  margin-bottom: ${({ theme }) => theme.spacing[4]};
  padding: ${({ theme }) => theme.spacing[3]};
  background: white;
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  border-radius: 8px;
  cursor: pointer;

  input {
    width: 18px;
    height: 18px;
    accent-color: ${({ theme }) => theme.colors.primary};
  }

  label {
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.gray700};
    cursor: pointer;
  }
`;

export const CompactPreview = styled.div`
  padding: ${({ theme }) => theme.spacing[4]};
  background: white;
  border: 1px dashed ${({ theme }) => theme.colors.gray300};
  border-radius: 8px;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.gray500};
  line-height: 1.6;
`;

export const MobileItemCard = styled.div`
  display: none;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[3]};
    padding: ${({ theme }) => theme.spacing[4]};
    border: 1px solid ${({ theme }) => theme.colors.gray200};
    border-radius: ${({ theme }) => theme.borderRadius.lg};
    margin-bottom: ${({ theme }) => theme.spacing[4]};
    background: ${({ theme }) => theme.colors.gray100};
  }
`;

export const MobileItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
`;

export const MobileItemLabel = styled.span`
  color: ${({ theme }) => theme.colors.gray500};
  font-weight: 500;
`;

export const MobileItemValue = styled.span`
  font-weight: 600;
`;

export const MethodSelectionGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;

  & > button {
    flex: 1 1 200px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
    gap: 0.75rem;

    & > button {
      flex: 1 1 auto;
    }
  }
`;
